import { render, staticRenderFns } from "./CompareChartStack2.vue?vue&type=template&id=2eb56314"
import script from "./CompareChartStack2.vue?vue&type=script&lang=js"
export * from "./CompareChartStack2.vue?vue&type=script&lang=js"
import style0 from "./CompareChartStack2.vue?vue&type=style&index=0&id=2eb56314&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports